const BrowserOverviewHeader = Object.freeze({
  SERVICE_NAME: 'serviceName',
  TOTAL_ALERTS: 'totalAlerts',
  APDEX: 'apdex',
  RESP: 'respTime',
  CPM: 'cpm',
  USERS_IMPACTED: 'totalUserImpacted',
  ERROR: 'errorCount',
});
const ApplicationOverviewHeader = Object.freeze({
  SERVICE_NAME: 'serviceName',
  APM_INFRA: 'apm-infra',
  TOTAL_ALERTS: 'totalAlerts',
  APDEX: 'apdex',
  ERROR: 'error',
  CPM: 'cpm',
});
const EndpointOverviewHeader = Object.freeze({
  ENDPOINT_NAME: 'endPointName',
  ERROR: 'error',
  RESP: 'respTime',
  CPM: 'cpm',
});

const MobileOverviewHeader = Object.freeze({
  SERVICE_NAME: 'serviceName',
  TOTAL_ALERTS: 'totalAlerts',
  CRASHCOUNT: 'totalCrashes',
  ERROR: 'error',
  RESP: 'respTime',
});

const VMOverviewHeader = Object.freeze({
  SERVICE_NAME: 'serviceName',
  CPU: 'cpu',
  RAM: 'ram',
  STORAGE: 'storage',
  NETWORK: 'network',
  AVAILABILITY: 'availability',
});

export {
  BrowserOverviewHeader,
  ApplicationOverviewHeader,
  EndpointOverviewHeader,
  MobileOverviewHeader,
  VMOverviewHeader,
};
